import React from 'react';

const Star = ({ fill = 0, size = 24 }) => {
  return (
    <div style={{ position: 'relative', display: 'inline-block', width: size, height: size }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <path
          d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.174L12 18.897l-7.336 3.865 1.402-8.174L.132 9.21l8.2-1.192z"
          fill="#e4e5e9"
        />
      </svg>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: `${fill * 100}%`,
          overflow: 'hidden'
        }}
      >
        <svg width={size} height={size} viewBox="0 0 24 24">
          <path
            d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.788 1.402 8.174L12 18.897l-7.336 3.865 1.402-8.174L.132 9.21l8.2-1.192z"
            fill="#ffc107"
          />
        </svg>
      </div>
    </div>
  );
};

export default Star;
